import React, { useState } from 'react';
import { changeOwnPassword } from './adminApi';

export default function ChangePassword({ restaurantId }) {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const update = (key, value) => setForm(prev => ({ ...prev, [key]: value }));
  async function submit(event) {
    event.preventDefault(); setError(''); setSuccess('');
    if (form.new_password !== form.confirm_password) { setError('New passwords do not match.'); return; }
    if (form.current_password === form.new_password) { setError('Choose a different new password.'); return; }
    setBusy(true);
    try {
      await changeOwnPassword(restaurantId, form.current_password, form.new_password);
      setSuccess('Password changed successfully.');
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) { setError(err.message || 'Could not change password.'); }
    finally { setBusy(false); }
  }
  return <section className="ra-panel ra-profile" aria-label="Change your password">
    <h2>Change your password</h2>
    <p>Enter your current password and choose a strong new password.</p>
    <form className="ra-profile-form" onSubmit={submit}>
      <label>Current password<input type="password" autoComplete="current-password" required value={form.current_password} onChange={e => update('current_password', e.target.value)} /></label>
      <label>New password<input type="password" autoComplete="new-password" required value={form.new_password} onChange={e => update('new_password', e.target.value)} /></label>
      <label>Confirm new password<input type="password" autoComplete="new-password" required value={form.confirm_password} onChange={e => update('confirm_password', e.target.value)} /></label>
      {error && <p className="ra-alert ra-alert-error" role="alert">{error}</p>}
      {success && <p className="ra-alert ra-alert-success" role="status">{success}</p>}
      <button className="ra-save" type="submit" disabled={busy}>{busy ? 'Updating…' : 'Change password'}</button>
    </form>
  </section>;
}
